import React from 'react'
import './table.scss'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function Tables({products_rows}) {
    const rows = [
        {
          id: 1143155,
          product: "Acer Nitro 5",
          img: "https://m.media-amazon.com/images/I/81bc8mA3nKL._AC_UY327_FMwebp_QL65_.jpg",
          date: "1 March",
          amount: 785,
          status: "Approved",
        },
        {
          id: 2235235,
          product: "Playstation 5",
          img: "https://m.media-amazon.com/images/I/31JaiPXYI8L._AC_UY327_FMwebp_QL65_.jpg",
          date: "1 March",
          amount: 900,
          status: "Pending",
        },
        {
          id: 2342353,
          product: "Redragon S101",
          img: "https://m.media-amazon.com/images/I/71kr3WAj1FL._AC_UY327_FMwebp_QL65_.jpg",
          date: "1 March",
          amount: 35,

          status: "Pending",
        },
        {
          id: 2357741,
          product: "Razer Blade 15",
          img: "https://m.media-amazon.com/images/I/71wF7YDIQkL._AC_UY327_FMwebp_QL65_.jpg",
          date: "1 March",
          amount: 920,
          
          status: "Approved",
        },
        {
          id: 2342355,
          product: "ASUS ROG Strix",
          img: "https://m.media-amazon.com/images/I/81hH5vK-MCL._AC_UY327_FMwebp_QL65_.jpg",
          date: "1 March",
          amount: 2000,
          
          status: "Pending",
        },
      ];
  return (
    <div className='table'>
         <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead className='thead'>
          <TableRow>
           <TableCell className='tableCell'>Tracking ID</TableCell>
           <TableCell className='tableCell'>Product </TableCell>
           <TableCell className='tableCell'>Date </TableCell>
           <TableCell className='tableCell'>Amount</TableCell>
           <TableCell className='tableCell'>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody className='tbody'>
          {products_rows?.map((row,index) => (
            <TableRow
              key={index}
            >
              <TableCell  className='tableCell'>
                {row.id}
              </TableCell>
              <TableCell className='tableCell'>
                <div className="cellWrapper">
                    <img src={row.img} alt="Product" className="image" />
                    {row.product}
                </div>
                </TableCell>
              <TableCell className='tableCell'>{row.date}</TableCell>
              <TableCell className='tableCell'>{'$ ' + row.amount}</TableCell>
              <TableCell className='tableCell'>
                <span className={'status ' + row.status}>{row.status}</span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </div>
  )
}

export default Tables